<script setup lang="ts">
/**
 * FullscreenLayout — 广告/故障/错误全屏布局，无任何 chrome
 * 用于：/ad-fullscreen / /maintenance / /error/:code
 *
 * E.3-1：使用 <slot /> 替代内嵌 <RouterView>，由 App.vue 控制路由
 */
defineOptions({ name: 'FullscreenLayout' })
</script>

<template>
  <div class="kiosk-fullscreen bg-kiosk-bg">
    <slot />
  </div>
</template>
